module.exports = __webpack_public_path__ + "img/control_device6.62e78890.png";